import React from 'react';
import classNames from 'classnames';
import styles from './LoadingPlaceholder.module.scss';

interface TitlePlaceholderProps {
  width?: number;
  widthPercent?: number;
  height?: number;
}

function LoadingPlaceholder({
  height = 21,
  width,
  widthPercent,
}: TitlePlaceholderProps) {
  return (
    <div
      className={classNames([styles.loadingPlaceholder])}
      style={{
        height,
        width: widthPercent ? `${width || widthPercent}%` : width,
      }}
    />
  );
}

export default LoadingPlaceholder;
